import {Component, NgZone} from '@angular/core';
import {Platform, IonicModule} from '@ionic/angular';
import {StatusBar, Style} from '@capacitor/status-bar';
import {LoadingSpinnerService} from './services/loading-service/loading-spinner.service';
import {OnPlatformEvents} from './utils/on-platform-events';
import {AppLanguageService} from './services/app-language/app-language.service';
import {NumberFormatService} from './services/number-format/number-format.service';
import {Capacitor, SystemBars, SystemBarsStyle} from '@capacitor/core';
import {EdgeToEdge} from '@capawesome/capacitor-android-edge-to-edge-support';
import {Device} from '@capacitor/device';
import {registerIcons} from './utils/icon-registry';

@Component({
  selector: 'app-root',
  imports: [IonicModule],
  templateUrl: './app.component.html'
})
export class AppComponent extends OnPlatformEvents {
  private readonly whiteHexString = '#FFFFFF';
  private readonly blackHexString = '#000000';

  constructor(ngZone: NgZone,
              private readonly platform: Platform,
              private readonly loadingService: LoadingSpinnerService,
              private readonly appLanguage: AppLanguageService,
              private readonly numberFormatService: NumberFormatService) {
    super(platform, ngZone);
    this.numberFormatService.ready$.subscribe();
    this.initializeApp();
    registerIcons();
  }

  ionPause(): void {
    this.loadingService.stopScheduler();
  }

  ionResume(): void {
    this.loadingService.startScheduler();
  }

  async initializeApp(): Promise<void> {
    this.platform.ready().then(() => {
      SystemBars.setStyle({style: SystemBarsStyle.Light});

      StatusBar.setBackgroundColor({color: this.whiteHexString});
      StatusBar.setStyle({style: Style.Light});
      this.appLanguage.setTranslationLanguage().subscribe();
      this.loadingService.startScheduler();
      if (this.platform.is('hybrid')) {
        StatusBar.setOverlaysWebView({overlay: false});
      }
    });

    if (Capacitor.getPlatform() === 'android') {
      const info = await Device.getInfo();
      const androidVersion = parseInt(info.osVersion, 10);

      if (androidVersion >= 15) {
        await EdgeToEdge.setStatusBarColor({color: this.whiteHexString});
        await EdgeToEdge.setNavigationBarColor({color: this.whiteHexString});
      } else {
        await EdgeToEdge.disable();
      }
    }
  }
}
